import { APIClient } from "./axiosClient";

const api = new APIClient();

const path = "/redeem-codes";

const redeemCodeApi = {
  getRedeemCodeList(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getRedeemCodeDetail(id: string | number, params: any = {}): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url, params);
  },

  createRedeemCode(params: any) {
    return api.post(path, params);
  },

  updateRedeemCode(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deleteRedeemCode(id: any) {
    return api.delete(`${path}/${id}`);
  },

  getRedeemCodeSumary(params: any): Promise<any> {
    const url = `${path}/summary`;
    return api.get(url, params);
  },
};

export default redeemCodeApi;
